import React, { useEffect, useState } from "react";
import {
  fetchBuOptions,
  getDepartmentListApi,
  getNamesofAgreement,
} from "../apis/userApis";
import {
  ActionIcon,
  Badge,
  Button,
  Input,
  Modal,
  Pagination,
  Select,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import {
  excelDownload,
  getComplianceBadgeColor,
  getDateStatus,
  getStatusColor,
  getStatusText,
  infoColor,
} from "./utilities";
import { IconEye, IconHistory, IconInfoCircle, IconSortAscending, IconSortDescending } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ObligationTranHistoryModal from "./ObligationTranHistoryModal";
import { getAllObligations } from "../apis/obligationApi";
import { getCookiesSession } from "../cookiesSession";
import UniversalTable from "../componenets/Common/UniversalTable";
import TablePagination from "../componenets/Common/TablePagination";

const CompletedObligation = () => {
  const cookieData = JSON.parse(getCookiesSession("LawSignaUserDataMaster"));
  const userData = cookieData.user;
  const [ahModal, setAhModal] = useState(false);
  const [ahId, setAhId] = useState(0);
  const [departments, setDepartments] = useState([]);
  const navigate = useNavigate();
  let filterForUser = {
    compliant: null,
    department:
      userData.loginAs.name === "CXO" || userData.loginAs.name === "DeptAdmin"
        ? userData.department
        : null,
    businessUnit: userData.loginAs.name === "COO" ? parseInt(userData.mapBusinessunit) : null,
    extraCol1: null,
  };
  const [filters, setFilters] = useState(filterForUser);
  const [configs, setConfigs] = useState({
    loading: true,
    obligations: null,
    count: 0,
    
  });
  const [buData, setBuData] = useState(null);

  const [categoryOptions, setCategoryOptions] = useState([
    "NDA",
    "Service Agreement",
  ]);

  useEffect(() => {
    const getNames = async () => {
      const response = await getNamesofAgreement();
      if (response.success) {
        setCategoryOptions(response.namesOfAgreement);
      }
    };
    getNames();
    const fetchDepartments =async()=>{
      const response = await getDepartmentListApi();
      if (response.success) {
        const data = response.departments.map(item => ({
          label: item.name,
          value: item.id,
        }));
        setDepartments(data);
      }
    }
    fetchDepartments()
  }, []);
  useEffect(() => {
    const getBuData = async () => {
      const response = await fetchBuOptions();
      const formattedData = response.result.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
      setBuData(formattedData);
    };
    getBuData();
  }, []);
  const [applyfilters, setApplyFilters] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize]= useState(10);
  const [partyName, setPartyName] = useState("");
  const [status, setStatus] = useState(null);
  let sr = (page - 1) * pageSize + 1;
  // useEffect(() => {
  //   const getObligation = async () => {
  //     const filterdata = Object.fromEntries(
  //       Object.entries(filters).filter(([key, value]) => value !== null)
  //     );
  //     const response = await getAllObligations({
  //       page: page,
  //       partyName: partyName,
  //       filters: filterdata,
  //       pageSize,
  //       status,
  //     });
  //     setConfigs({
  //       loading: false,
  //       obligations: response.obligations,
  //       count: response.count,
  //     });
  //     console.log("response: ", response);
  //   };
  //   getObligation();
  // }, [page, applyfilters, pageSize]);
  const onViewClick = ({ id }) => {
    navigate(`/viewobligation/${id}`);
  };
  const [expandedId, setExpandedId] = useState(null); // Tracks the currently expanded obligation by ID

  const handleExpand = (id) => {
    setExpandedId(id); 
  };

   const [sortByOptions, setSortByOptions] = useState({ key: "duedate", value: "asc" });

  const handleKeyChange = (val) => {
    setSortByOptions({ ...sortByOptions, key: val });
  };

  const toggleOrder = () => {
    setSortByOptions({
      ...sortByOptions,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    });
  };
  // 1. Add state to hold the data for export
const [csvData, setCsvData] = useState([]);

// 2. Fetch Obligations & Prepare Export Data
  // useEffect(() => {
  //   const getObligation = async () => {
  //     setConfigs(prev => ({ ...prev, loading: true }));
  //     const filterdata = Object.fromEntries(
  //       Object.entries(filters).filter(([_, value]) => value !== null)
  //     );

  //     const response = await getAllObligations({
  //       page: page,
  //       partyName: partyName,
  //       filters: filterdata,
  //       pageSize,
  //       status,
  //     });

  //     setConfigs({
  //       loading: false,
  //       obligations: response.obligations,
  //       count: response.count,
  //     });

  //     // Capture data for export (Use exportData from API if available, else current page)
  //     setCsvData(response.exportData || response.obligations);
  //   };
  //   getObligation();
  // }, [page, applyfilters, pageSize]);

  useEffect(() => {
  const getObligation = async () => {
    setConfigs(prev => ({ ...prev, loading: true }));
    const filterdata = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== null)
    );

    // NEW: Create sort object for API
    const sortOption = { [sortByOptions.key]: sortByOptions.value };

    const response = await getAllObligations({
      page: page,
      partyName: partyName,
      filters: filterdata,
      pageSize,
      status,
      sortByOptions: sortOption, // NEW: Pass sorting to API
    });

    setConfigs({
      loading: false,
      obligations: response.obligations,
      count: response.count,
    });
    setCsvData(response.exportData || response.obligations);
  };
  getObligation();
}, [page, applyfilters, pageSize, sortByOptions]); // NEW: Added sortByOptions here

  // 3. Export Handler
  const onExport = () => {
    if (csvData && csvData.length > 0) {
      const columnHeaders = Object.keys(csvData[0]);
      excelDownload({
        data: csvData,
        headers: columnHeaders,
        name: `Obligations_Monitor_${new Date().toISOString().split('T')[0]}`,
      });
    } else {
      alert("No data to export");
    }
  };

const obligationHeaders = [
  {
    label: "id",
    render: (row) => (
      <Text size="sm" weight={600} color="#43A3B3">{`#${row.id}`}</Text>
    ),
  },
  { label: "title", key: "title" },
  {
    label: "obligation",
    style: { maxWidth: '250px' },
    render: (row) => (
      <div style={{ cursor: "pointer" }} onClick={() => handleExpand(row.id)}>
        <Text size="sm">
          {expandedId === row.id
            ? row.desc
            : `${row.desc.slice(0, 50)}${row.desc.length > 50 ? "..." : ""}`}
        </Text>
      </div>
    ),
  },
  { label: "contract category", key: "extraCol1" },
  { label: "bu", key: "businessUnit" },
  { label: "second party", key: "connectedParty" },
  { label: "department", render: (row) => row.dept?.name || "--" },
  { label: "assignee", render: (row) => row.assignTo?.name || "Unassigned" },
  {
    label: "status",
    render: (row) => {
      const status = getDateStatus(row.startDate, row.duedate, row.reminderTime);
      return (
        <Badge variant="light" color={getStatusColor(status)}>
          {getStatusText(status)}
        </Badge>
      );
    },
  },
  {
    label: "compliance",
    render: (row) => (
      <Badge variant="light" color={getComplianceBadgeColor(row.compliant)}>
        {row.compliant}
      </Badge>
    ),
  },
  {
    label: "actions",
    align: "left",
    render: (row) => (
      <div className="flex flex-row justify-end">
        {/* View Icon */}
        <ActionIcon onClick={() => onViewClick({ id: row.id })}>
          <IconEye size={20} color="#1b6f8d"/>
        </ActionIcon>

        {/* History Icon */}
        <ActionIcon onClick={() => {
          setAhId(row.id);
          setAhModal(true);
        }}>
          <IconHistory size={20} color="#1b6f8d"/>
        </ActionIcon>

        {/* Info Icon */}
        {row.extraCol3 !== "" ? (
          <ActionIcon>
            <IconInfoCircle color={infoColor(row.extraCol3)} size={20} />
          </ActionIcon>
        ) : (
          <div style={{ width: 28 }} /> // Maintain alignment spacing
        )}
      </div>
    ),
  },
];

  return (
    <>
      {/* <Text className="primary-heading">Obligations Register</Text> */}

      <div className="grid grid-cols-6 gap-4 m-4">
        <Select
          placeholder="Select Compliance"
          label="compliance"
          value={filters.compliant}
          data={[
            { label: "upcoming", value: "upcoming" },
            { label: "non-compliant", value: "non-compliant" },
            {
              label: "partially-compliant",
              value: "partially-compliant",
            },
            { label: "delayed-compliant", value: "delayed-compliant" },
            { label: "compliant", value: "compliant" },
          ]}
          onChange={(val) => setFilters({ ...filters, compliant: val })}
        />
        <Select
          placeholder="Select Status"
          label="status"
          value={status}
          data={[
            { label: "upcoming", value: "upcoming" },
            {
              label: "due",
              value: "due",
            },
            { label: "overdue", value: "overdue" },
          ]}
          onChange={(val) => setStatus(val)}
        />
        {userData.role !== "DeptAdmin" && userData.role !== "CXO" && (
          <Select
            label="department"
            placeholder="Select Department"
            data={departments}
            onChange={(val) => setFilters({ ...filters, department: val })}
            value={filters.department}
          />
        )}
        {buData !== null && userData.role !== "COO" && (
          <Select
            label="business unit"
            placeholder="Select Business Unit"
            value={filters.businessUnit}
            data={buData}
            onChange={(val) => setFilters({ ...filters, businessUnit: val })}
          />
        )}
        <Select
          label="contract category"
          placeholder="Contract Category"
          value={filters.extraCol1}
          data={categoryOptions}
          onChange={(val) => setFilters({ ...filters, extraCol1: val })}
        />
        <TextInput
          label="second party name"
          placeholder="Type Party Name"
          value={partyName}
          onChange={(e) => setPartyName(e.target.value)}
        />
      </div>
      <div className="m-4">
        <Button
          onClick={() => setApplyFilters(!applyfilters)}
          className="mr-4"
          variant="outline"
        >
          Search
        </Button>
        <Button
          onClick={() => {
            setFilters(filterForUser);
            setPartyName("");
            setStatus(null);
            setApplyFilters(!applyfilters);
          }}
          // color="red"
          variant="contained"
        >
          Clear
        </Button>
      </div>
      {/* <div className="flex justify-end m-4">
        <Button onClick={onExport} disabled={!csvData.length}>export</Button>
      </div> */}
      <div className="flex justify-end items-end m-4 gap-4">
        <div className="flex items-center">
          <Select
            label="sort by"
            value={sortByOptions.key}
            onChange={(val) => handleKeyChange(val)}
            data={[
              { label: "due date", value: "duedate" },
              { label: "start date", value: "startDate" },
              { label: "second party", value: "connectedParty" },
              { label: "id", value: "id" },
              { label: "title", value: "title" },
            ]}
          />

          <ActionIcon className="mx-2 mt-4" onClick={toggleOrder}>
            {sortByOptions.value === "asc" ? (
              <IconSortAscending size={24} />
            ) : (
              <IconSortDescending size={24} />
            )}
          </ActionIcon>
        </div>

        <Button
          onClick={onExport}
          disabled={!csvData.length}
          // className="success"
        >
          Export
        </Button>
      </div>
      <div className="m-4">
        {!configs.loading && configs.obligations && (
          // <>
          //   <Table striped>
          //     <thead className="text-center">
          //       <tr>
          //         <th style={{ textAlign: "center" }}>id</th>
          //         <th style={{ textAlign: "center" }}>title</th>
          //         <th style={{ textAlign: "center" }}>obligation</th>
          //         <th style={{ textAlign: "center" }}>contract category</th>
          //         <th style={{ textAlign: "center" }}>business unit</th>
          //         <th style={{ textAlign: "center" }}>second party</th>
          //         <th style={{ textAlign: "center" }}>department</th>
          //         <th style={{ textAlign: "center" }}>status</th>
          //         <th style={{ textAlign: "center" }}>compliance</th>
          //         <th>&nbsp;</th>
          //         <th>&nbsp;</th>
          //         <th>&nbsp;</th>
          //       </tr>
          //     </thead>
          //     <tbody>
          //       {configs.obligations.map((obligation) => (
          //         <tr key={obligation.id}>
          //           <td style={{ textAlign: "center" }}>{obligation.id}</td>
          //           <td style={{ textAlign: "center" }}>{obligation.title}</td>
          //           <td style={{ textAlign: "center" }}>
          //             {expandedId === obligation.id
          //               ? obligation.desc // Show full description if expanded
          //               : obligation.desc.slice(0, 50)}
          //             {/* Truncated description */}
          //             {expandedId !== obligation.id &&
          //               obligation.desc.length > 50 && (
          //                 <span
          //                   onClick={() => handleExpand(obligation.id)}
          //                   style={{
          //                     cursor: "pointer",
          //                   }}
          //                 >
          //                   ...
          //                 </span>
          //               )}
          //           </td>
          //           <td style={{ textAlign: "center" }}>
          //             {obligation.extraCol1}
          //           </td>
          //           <td style={{ textAlign: "center" }}>
          //             {obligation.businessUnit}{" "}
          //           </td>
          //           <td style={{ textAlign: "center" }}>
          //             {obligation.connectedParty}
          //           </td>
          //           <td style={{ textAlign: "center" }}>
          //             {obligation.dept.name}
          //           </td>

          //           <td>
          //             <Badge
          //               variant="light"
          //               color={getStatusColor(
          //                 getDateStatus(
          //                   obligation.startDate,
          //                   obligation.duedate,
          //                   obligation.reminderTime
          //                 )
          //               )}
          //             >
          //               {getStatusText(
          //                 getDateStatus(
          //                   obligation.startDate,
          //                   obligation.duedate,
          //                   obligation.reminderTime
          //                 )
          //               )}
          //             </Badge>
          //           </td>
          //           <td style={{ textAlign: "center" }}>
          //             <Badge
          //               variant="light"
          //               color={getComplianceBadgeColor(obligation.compliant)
          //               }
          //             >
          //               {obligation.compliant}
          //             </Badge>
          //           </td>
          //           <td style={{ textAlign: "center" }}>
          //             <div className="flex flex-row mr-4">
          //               <ActionIcon
          //                 onClick={() => {
          //                   onViewClick({ id: obligation.id });
          //                 }}
          //                 color="white"
          //               >
          //                 <IconEye size={24} />
          //               </ActionIcon>
          //               {/* )} */}
          //             </div>
          //           </td>
          //           <td style={{ textAlign: "center" }}>
          //             <div className="flex flex-row mr-4">
          //               <ActionIcon
          //                 color="white"
          //                 onClick={() => {
          //                   setAhId(obligation.id);
          //                   setAhModal(true);
          //                 }}
          //               >
          //                 <IconHistory size={24} />
          //               </ActionIcon>
          //             </div>
          //           </td>
          //           <td style={{ textAlign: "center" }}>
          //             <div className="flex flex-row mr-4">
          //               {obligation.extraCol3 !== "" && (
          //                 <ActionIcon color="white">
          //                   <IconInfoCircle
          //                     color={infoColor(obligation.extraCol3)}
          //                     size={24}
          //                   />
          //                 </ActionIcon>
          //               )}
          //             </div>
          //           </td>
          //         </tr>
          //       ))}
          //     </tbody>
          //   </Table>
          //   <div className="flex flex-row justify-center my-4 gap-4">
          //     <Pagination
          //       page={page}
          //       onChange={(page) => {
          //         setPage(page);
          //       }}
          //       total={Math.ceil(configs.count / pageSize)}
          //     />

          //     <Select
          //       style={{ width: "70px" }}
          //       value={pageSize + ""}
          //       data={["10", "20", "50"]}
          //       onChange={(val) =>
          //         setPageSize(parseInt(val) )
          //       }
          //     />
          //   </div>
          // </>

          <>
            <UniversalTable
              headers={obligationHeaders}
              data={configs.obligations}
              loading={configs.loading}
            />

            <TablePagination
              totalCount={configs.count}
              page={page}
              pageSize={pageSize}
              dataLength={configs.obligations?.length || 0}
              onPageChange={(val) => setPage(val)}
              onPageSizeChange={(val) => {
                setPageSize(val);
                setPage(1);
              }}
            />
          </>
        )}
        <Modal
          opened={ahModal}
          onClose={() => {
            setAhModal(false);
            setAhId(0);
          }}
          title="oblligation action history"
          size="calc(80vw)"
        >
          <ObligationTranHistoryModal id={ahId} />
        </Modal>
      </div>
    </>
  );
};

export default CompletedObligation;
